import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Client-side navigation doesn't reset scroll position like a full page load does — jump to top on every route change (e.g. clicking a "Weiterlesen" link). */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
